import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormGroupService {


  url = environment.serverAPI4 + "/api/dynamicformgroup"; 
  
  constructor(private http: HttpClient) { }

  getAllDynamicFormGroup(Page: any, size: any, sort: any,typeId: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&typeId=${typeId}`);
  }

  getAllDynmaicFormDropDown(typeId: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?&typeId=${typeId}`);
  }


  getDynamicFormGroupById(formGroupId: number): Observable<Object> {
    return this.http.get(`${this.url}/${formGroupId}`);
  }

  addOrEditDynamicFormGroup(dynamicformgroup: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, dynamicformgroup);
  }

  DynamicFormGroupSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

}
